/*
 * Star map time picker — the "Select Time" modal (hour / minute / AM-PM
 * wheels). The wheels are SkylitWheel columns (assets/skylit-wheel.js); this
 * file owns the modal and the hidden #timePicker hour/minute selects and
 * AM/PM radios the rest of the customizer reads.
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {

    setTimeout(initTimePicker, 300);

    function initTimePicker() {
      const trigger = document.getElementById('timePickerTrigger');
      const display = document.getElementById('timePickerDisplay');
      const overlay = document.getElementById('timePickerOverlay');
      const cancelBtn = document.getElementById('timePickerCancel');
      const doneBtn = document.getElementById('timePickerDone');
      const confirmBtn = document.getElementById('timePickerConfirm');
      const hourColumn = document.getElementById('hourColumn');
      const minuteColumn = document.getElementById('minuteColumn');
      const meridiemColumn = document.getElementById('meridiemColumn');

      const hourSelect = document.querySelector('#timePicker .hours-dropdown');
      const minuteSelect = document.querySelector('#timePicker .minutes-dropdown');
      const amRadio = document.getElementById('timePickerMeridianAM');
      const pmRadio = document.getElementById('timePickerMeridianPM');

      if (!trigger || !overlay || !window.SkylitWheel) return;

      let selectedHour = 11;
      let selectedMinute = 11;
      let selectedMeridiem = 'PM';
      let hourWheel, minuteWheel, meridiemWheel;
      let returnFocus = null;

      function readControls(strict) {
        if (hourSelect && hourSelect.value !== '') {
          const h = parseInt(hourSelect.value);
          if (!isNaN(h) && (!strict || (h >= 1 && h <= 12))) selectedHour = h;
        }
        if (minuteSelect && minuteSelect.value !== '') {
          const m = parseInt(minuteSelect.value);
          if (!isNaN(m) && (!strict || (m >= 0 && m <= 59))) selectedMinute = m;
        }
        if (pmRadio && pmRadio.checked) selectedMeridiem = 'PM';
        else if (amRadio && amRadio.checked) selectedMeridiem = 'AM';
      }

      function init() {
        readControls(true);

        const minutes = [];
        for (let m = 0; m < 60; m++) minutes.push({ value: m, label: m.toString().padStart(2, '0') });

        hourWheel = SkylitWheel.create(hourColumn, {
          itemClass: 'time-picker-item', label: 'Hour',
          items: [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], value: selectedHour,
          onChange: (v) => { selectedHour = parseInt(v); },
          onEnter: applySelection
        });
        minuteWheel = SkylitWheel.create(minuteColumn, {
          itemClass: 'time-picker-item', label: 'Minute',
          items: minutes, value: selectedMinute,
          onChange: (v) => { selectedMinute = parseInt(v); },
          onEnter: applySelection
        });
        meridiemWheel = SkylitWheel.create(meridiemColumn, {
          itemClass: 'time-picker-item', label: 'AM or PM',
          items: ['AM', 'PM'], value: selectedMeridiem,
          onChange: (v) => { selectedMeridiem = v; },
          onEnter: applySelection
        });
        [doneBtn, confirmBtn].forEach(SkylitWheel.hapticButton);

        updateDisplay();
      }

      function updateDisplay() {
        const minStr = selectedMinute.toString().padStart(2, '0');
        display.textContent = `${selectedHour}:${minStr} ${selectedMeridiem}`;
      }

      function openPicker() {
        if (!hourWheel) return;
        readControls(false);
        hourWheel.setValue(selectedHour);
        minuteWheel.setValue(selectedMinute);
        meridiemWheel.setValue(selectedMeridiem);

        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        returnFocus = document.activeElement;

        requestAnimationFrame(() => {
          hourWheel.sync(); minuteWheel.sync(); meridiemWheel.sync();
          try { hourColumn.focus({ preventScroll: true }); } catch (e) { /* noop */ }
        });
      }

      function closePicker() {
        overlay.classList.remove('active');
        document.body.style.overflow = '';
        if (returnFocus && returnFocus.focus) {
          try { returnFocus.focus({ preventScroll: true }); } catch (e) { /* noop */ }
        }
        returnFocus = null;
      }

      function applySelection() {
        if (hourSelect) {
          const hourOption = Array.from(hourSelect.options).find(opt => parseInt(opt.value) === selectedHour);
          if (hourOption) hourSelect.value = hourOption.value;
        }

        if (minuteSelect) {
          const minValue = selectedMinute.toString().padStart(2, '0');
          const minOption = Array.from(minuteSelect.options).find(opt => opt.value === minValue);
          if (minOption) minuteSelect.value = minOption.value;
        }

        if (selectedMeridiem === 'AM' && amRadio) amRadio.checked = true;
        else if (selectedMeridiem === 'PM' && pmRadio) pmRadio.checked = true;

        $(minuteSelect).trigger('change');

        updateDisplay();
        closePicker();
      }

      trigger.addEventListener('click', openPicker);
      cancelBtn.addEventListener('click', closePicker);
      doneBtn.addEventListener('click', applySelection);
      if (confirmBtn) confirmBtn.addEventListener('click', applySelection);

      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closePicker();
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && overlay.classList.contains('active')) closePicker();
      });

      if (hourSelect) {
        hourSelect.addEventListener('change', () => {
          selectedHour = parseInt(hourSelect.value) || selectedHour;
          updateDisplay();
        });
      }
      if (minuteSelect) {
        minuteSelect.addEventListener('change', () => {
          const m = parseInt(minuteSelect.value);
          if (!isNaN(m)) selectedMinute = m; // 00 is a real minute, not a fallback
          updateDisplay();
        });
      }
      if (amRadio) {
        amRadio.addEventListener('change', () => {
          if (amRadio.checked) selectedMeridiem = 'AM';
          updateDisplay();
        });
      }
      if (pmRadio) {
        pmRadio.addEventListener('change', () => {
          if (pmRadio.checked) selectedMeridiem = 'PM';
          updateDisplay();
        });
      }

      init();

      setTimeout(function() {
        readControls(true);
        updateDisplay();
      }, 200);
    }
  });
})();
